module.exports = __webpack_public_path__ + "img/kachel-ZAHNMUND_MICROSILVERZAHNCREME.0bc63a66.png";